export const apiEndpoint = "/api";

const statusCodes = {
  OK: 200,
  Unauthorized: 302,
};

function errorHandler({ code, message, data }, { $bus, defaultErrorHandler }) {
  switch (code) {
    case statusCodes.Unauthorized:
      $bus.emit("need-yiban-login", data);
      break;
    default:
      defaultErrorHandler(message);
  }
}

export function responseHandler(responseData, responseOptions) {
  const { code, data, message } = responseData;

  if (code === statusCodes.OK) {
    return Promise.resolve(data);
  } else {
    errorHandler({ code, message, data }, responseOptions);

    return Promise.reject(responseData);
  }
}
